import { render, staticRenderFns } from "./DashboardModule.vue?vue&type=template&id=f60b9038&scoped=true&"
import script from "./DashboardModule.vue?vue&type=script&lang=js&"
export * from "./DashboardModule.vue?vue&type=script&lang=js&"
import style0 from "./DashboardModule.vue?vue&type=style&index=0&id=f60b9038&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f60b9038",
  null
  
)

export default component.exports